import { WorkspaceSubscriptionAccountOfferEventRecord } from '../../../../../../../../server-services/query-records/workspace-records';
import { WorkspaceChangeSubscriptionSpecificHandler } from '../types';

export let onModifyAccountOfferSubscriptionHandler: WorkspaceChangeSubscriptionSpecificHandler = (
  cache,
  event: WorkspaceSubscriptionAccountOfferEventRecord
) => {};
